// extracted by mini-css-extract-plugin
export default {"content":"xL-z","lookName":"yL-z","shopTheLookContainer":"zL-z","productContainer":"AL-z","imageContainer":"BL-z","mainImage":"CL-z"};